import React from 'react'
import './Loader.scss'

const Loader = () => {
  return (
    <div className='loader'>
      <div className='spinner_container'>
        <div className='spinner-border spinner_custom' role='status'></div>
      </div>
    </div>
  )
}

export default Loader
